import { useEffect, useMemo, useRef, useState } from 'react';
import TimelineUtil from "../TimelineUtil.js";
import Projection from "../Projection.js";
export default function useTimelineProjection(opts) {
  const {
    range
  } = opts;
  const timelineStageRef = useRef();
  const [totalPixels, setTotalPixels] = useState(30000);
  const [height, setHeight] = useState(0);
  const projection = useMemo(() => {
    return new Projection({
      totalPixels,
      startValue: TimelineUtil.coerceDate(range?.start).getTime(),
      stopValue: TimelineUtil.coerceDate(range?.end).getTime()
    });
  }, [range, totalPixels]);
  const stageResizeObserver = useMemo(() => {
    return new ResizeObserver(entries => {
      const stage = entries[0].target;
      setTotalPixels(stage.offsetWidth);
      setHeight(stage.offsetHeight);
    });
  }, []);
  useEffect(() => {
    const stageEl = timelineStageRef.current;
    stageResizeObserver.observe(stageEl);
    return () => {
      stageResizeObserver.unobserve(stageEl);
    };
  }, [stageResizeObserver]);
  return {
    height,
    projection,
    ref: timelineStageRef
  };
}